import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Lodash
import _noop from 'lodash/noop';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Components
import { Button, FontIcon } from '@tekion/tmatter';

// Styles
import styles from './pinAction.module.scss';
var PinAction = function PinAction(props) {
  var _props$pinAction = props.pinAction,
    pinAction = _props$pinAction === void 0 ? EMPTY_OBJECT : _props$pinAction;
  var className = pinAction.className,
    _pinAction$isSelected = pinAction.isSelected,
    isSelected = _pinAction$isSelected === void 0 ? _noop : _pinAction$isSelected,
    onClick = pinAction.onClick,
    key = pinAction.key,
    size = pinAction.size,
    iconName = pinAction.iconName;
  var isPinActionSelected = isSelected(pinAction);
  var pinActionClassName = cx(className, _defineProperty({}, styles.pinIconSelected, isPinActionSelected));
  return /*#__PURE__*/React.createElement(Button, {
    view: "plain",
    className: pinActionClassName,
    onClick: onClick,
    key: key
  }, /*#__PURE__*/React.createElement(FontIcon, {
    size: size
  }, iconName));
};
PinAction.propTypes = {
  pinAction: PropTypes.object.isRequired
};
export default PinAction;